import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  IconButton
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { DELETE_TOOL } from '../../gql';
import { useMutation } from '@apollo/client';
import { errorToast, successToast } from '../../../common/utils/alert';
import { errorMessages } from '../../../common/utils/constants';

interface DeleteToolsAndTechnologyProps {
  open: boolean;
  handleClose: () => void;
  deleteToolCallback: (toolId: string) => void;
  id: string;
}

const DeleteToolsAndTechForm: React.FC<DeleteToolsAndTechnologyProps> = ({
  open,
  handleClose,
  deleteToolCallback,
  id
}) => {
  const [deleteToolMutation] = useMutation(DELETE_TOOL);

  const handleDelete = (): void => {
    deleteToolMutation({
      variables: {
        id
      }
    })
      .then((response) => {
        successToast('Tool/Technology removed');
        const deletedSkill = JSON.parse(response.data.deleteSkill);
        deleteToolCallback(deletedSkill.data);
      })
      .catch(() => {
        errorToast(errorMessages.ErrorMessageDeletingTools);
      });

    close();
  };

  const close = (): void => {
    handleClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      PaperProps={{
        sx: {
          borderRadius: '28px',
          backgroundColor: '#f4f2fd',
          padding: '24px',
          width: '60%',
          display: 'flex',
          flexDirection: 'column',
          gap: '40px'
        }
      }}
    >
      <DialogContent sx={{ padding: '0' }}>
        <Box sx={{ justifyContent: 'space-between', display: 'flex' }}>
          <DialogContentText
            sx={{
              display: 'flex',
              fontSize: '24px',
              textAlign: 'center',
              color: '#1A1B1F',
              marginTop: '12px',
              flexWrap: 'wrap',
              wordWrap: 'break-word'
            }}
          >
            Are you sure you want to remove this Tool or Technology?
          </DialogContentText>
          <IconButton onClick={close} sx={{ height: '24px', width: '24px' }}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogContent>
      <DialogActions sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Button
          sx={{
            textTransform: 'none',
            fontSize: '18px',
            color: '#295DAB',
            fontWeight: '500'
          }}
          onClick={close}
        >
          Dismiss
        </Button>
        <Button
          sx={{
            textTransform: 'none',
            fontSize: '18px',
            color: '#295DAB',
            fontWeight: '500'
          }}
          onClick={() => handleDelete()}
          autoFocus
        >
          Yes,Approve
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteToolsAndTechForm;
